export default {"src":"/_next/static/media/lassie_loader_white_128.0b8e8cb5.gif","height":118,"width":128,"blurWidth":0,"blurHeight":0};